'use client';

import { useQuery } from '@tanstack/react-query';
import { useAuth } from 'react-oidc-context';

import { getReviewInfo } from '../apis/feedbacks/shared';
import type { FeedbackTopicType, ReviewInfoResponseType } from '../types/feedbacks';

type Args = {
  topicId: string;
  topicType: FeedbackTopicType;
  enabled?: boolean;
  onSuccess?: (d: ReviewInfoResponseType) => void;
};

export const useReviewInfo = (args: Args) => {
  const { topicId, topicType, onSuccess, enabled } = args;
  const { user } = useAuth();
  return useQuery(
    ['review-info', topicId, topicType],
    async () => (await getReviewInfo(topicType, topicId, user?.access_token as string)).data,
    {
      enabled,
      onSuccess(data) {
        onSuccess && onSuccess(data);
      },
    },
  );
};
